import { IComboBoxOption } from "@fluentui/react";

const useDropDownAreaAndChart = (input) => {
  const { isFileExcelExisting, isComponentInstance, isLocked } = input;
  const type = input.type ?? "area";
  const areasItems: IComboBoxOption[] = computeAreasItems(input);

  return { type, areasItems, isFileExcelExisting, isComponentInstance, isLocked };
};

function computeAreasItems(input): IComboBoxOption[] {
  if (!input.sheetsAreaChartMap || !input.sheet) {
    return [];
  }
  let result: IComboBoxOption[] = [];
  input.sheetsAreaChartMap.forEach((value: string[], key: string) => {
    if (input.sheet?.code == key) {
      result = (value ?? []).map((area) =>
        area.includes("!") ? createIComboBoxFromDistinctAreas(area) : createIComboBoxFromAreas(area)
      );
    }
  });
  return result;
}

function createIComboBoxFromAreas(areaValue: string): IComboBoxOption {
  return {
    key: areaValue,
    text: areaValue,
  };
}

function createIComboBoxFromDistinctAreas(areaValue: string): IComboBoxOption {
  let areaValueWithoutSource = areaValue.split("!")[1];
  return {
    key: areaValue,
    text: areaValueWithoutSource,
  };
}

export default useDropDownAreaAndChart;
